import { useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import useStickyHeader from './useStickyHeader';

const HeaderTwo = ({ btnStyle = '', HeaderSTyle = '' }) => {
    const [offcanvasShow, setOffcanvasShow] = useState(false);
    const sticky = useStickyHeader(50);

    return (
        <>
            <header className={`rn-header header-default header-left-align ${HeaderSTyle} ${sticky ? 'sticky' : ''}`}>
                <div className="container position-relative">
                    <div className="row align-items-center">
                        <div className="col-lg-9 col-md-6 col-4 position-static">
                            <div className="header-center d-flex">
                                <nav className="mainmenu-nav d-none d-lg-block" aria-label="Główna nawigacja">
                                    <Nav />
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-8">
                            <div className="header-right">
                                <div className="header-btn">
                                    <a className={`btn-default ${btnStyle}`} href="tel:+48668650693"><span className="header-call__desktop">ZADZWOŃ TERAZ</span><span className="header-call__mobile">ZADZWOŃ</span></a>
                                </div>
                                <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <button
                                        type="button"
                                        className="hamberger-button"
                                        onClick={() => setOffcanvasShow(true)}
                                        aria-label="Otwórz menu"
                                        aria-expanded={offcanvasShow}
                                    >
                                        <FiMenu />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={offcanvasShow} onClose={() => setOffcanvasShow(false)} />
        </>
    );
};

export default HeaderTwo;
